module.exports = __webpack_public_path__ + "img/kebijakan-sk.f565f31d.svg";